module.exports = __webpack_public_path__ + "img/k3p_float_ico.48a5393b.png";